// A faint rounded outline on the topbar's clickable preference controls (theme, language,
// settings), so they read as buttons rather than loose glyphs. Kept in one place so the
// three stay identical.
export const TOPBAR_CONTROL_OUTLINE =
  'rounded-lg border border-foreground/15 hover:border-foreground/30 focus-visible:border-ring';
